import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AllAbsences.css';

function EditAbsence() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ status: '', comment: '' });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const token = sessionStorage.getItem('jwtToken');
  const { userInfo } = useAuth();
  const userRole = userInfo?.role || '';

  useEffect(() => {
    const fetchAbsence = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/absence/getabsence/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setForm({
          status: res.data.status,
          comment: res.data.comment || '',
        });
      } catch (error) {
        console.error('Fout bij ophalen absentie:', error);

        await Swal.fire({
          toast: true,
          position: 'top',
          icon: 'error',
          title: 'Fout bij ophalen absentie',
          showConfirmButton: false,
          timer: 1800,
          timerProgressBar: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchAbsence();
  }, [id, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/absence/update/${id}`,
        form,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      await Swal.fire({
        toast: true,
        position: 'top',
        icon: 'success',
        title: 'Absentie succesvol bijgewerkt',
        showConfirmButton: false,
        timer: 1800,
        timerProgressBar: true,
      });

      navigate('/absences');
    } catch (error) {
      console.error('Fout bij bijwerken absentie:', error);

      await Swal.fire({
        toast: true,
        position: 'top',
        icon: 'error',
        title: 'Fout bij bijwerken absentie',
        showConfirmButton: false,
        timer: 2200,
        timerProgressBar: true,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="absence-form-page">
      <div className="absence-form-shell">
        <button type="button" className="absence-back-button" onClick={() => navigate('/absences')}><i className="bi bi-arrow-left" />Terug naar absenties</button>
        <section className="absence-form-card">
          <header className="absence-form-header"><span className="absence-form-icon"><i className="bi bi-pencil-square" /></span><div><span className="absence-form-eyebrow">Aanwezigheid</span><h1>Absentie bewerken</h1><p>Werk de status of aanvullende informatie van de melding bij.</p></div></header>
          {loading ? <div className="ab-state" role="status"><span className="ab-loader" /><strong>Absentie laden</strong><span>Even geduld</span></div> : <form className="absence-form-body" onSubmit={handleSubmit}>
        <div className="absence-field">
          <label htmlFor="edit-absence-status">Status</label>
          <select
            id="edit-absence-status"
            className="absence-control"
            value={form.status}
            onChange={(e) => setForm({ ...form, status: e.target.value })}
            disabled={['ouder', 'leerling'].includes(userRole)}
          >
            <option value="Ingediend">Ingediend</option>
            <option value="In_behandeling">In behandeling</option>
            <option value="Verwerkt">Verwerkt</option>
            <option value="Afgewezen">Afgewezen</option>
          </select>
        </div>

        <div className="absence-field">
          <label htmlFor="edit-absence-comment">Opmerking</label>
          <textarea
            id="edit-absence-comment"
            disabled={userRole === 'ouder' && form.status !== 'Ingediend'}
            className="absence-control absence-textarea"
            rows="3"
            value={form.comment}
            onChange={(e) => setForm({ ...form, comment: e.target.value })}
          />
        </div>

        <div className="absence-form-actions">
          <button type="button" className="absence-secondary-button" onClick={() => navigate('/absences')}>Annuleren</button>
          <button type="submit" className="absence-submit-button" disabled={submitting}>{submitting ? 'Opslaan¦' : <><i className="bi bi-check2-circle" />Wijzigingen opslaan</>}</button>
        </div>
      </form>}
        </section>
      </div>
    </main>
  );
}

export default EditAbsence;